if (!customElements.get('recently-viewed')) {
  customElements.define(
    'recently-viewed',
    class RecentlyViewed extends HTMLElement {
      async connectedCallback() {
        this.products = JSON.parse(localStorage.getItem('recently-viewed-products')) ?? [];

        this.setIntersectionObserver();
      }

      /**
       * Sets the intersection observer events.
       */
      setIntersectionObserver() {
        this.observer = new IntersectionObserver((entries) => this.handleIntersection(entries));

        this.observer.observe(this);
      }

      /**
       * Handles the section intersection event.
       * @param {Array} entries - The event entries.
       */
      handleIntersection(entries) {
        const { isIntersecting } = entries[0];

        if (!isIntersecting) {
          return;
        }

        this.observer.disconnect();

        fetch(
          `${theme.routes.search_url}?section_id=${this.dataset.sectionId}&q=${this.products
            .filter((product) => product !== this.dataset.productId)
            .map((product) => `id:${product}`)
            .join('+OR+')}`
        )
          .then((response) => response.text())
          .then((response) => {
            const html = new DOMParser().parseFromString(response, 'text/html');
            const section = html.getElementById(`shopify-section-${this.dataset.sectionId}`);

            if (section) {
              const productCarousel = section.querySelector('[js-recently-viewed="productCarousel"]');
              const placeholder = this.querySelector('[js-recently-viewed="productCarouselPlaceholder"]');

              if (productCarousel && placeholder) {
                placeholder.replaceWith(productCarousel);
              }
            }
          });
      }
    }
  );
}
